const watermark: any = {}

const setWatermark = (str: any) => {
  const id = 'watermark'

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id) as Node)
  }

  const can = document.createElement('canvas')
  can.width = 200
  can.height = 120

  const cans = can.getContext('2d')
  if (cans) {
    cans.rotate((-20 * Math.PI) / 180)
    cans.font = '15px Vedana'
    cans.fillStyle = 'rgba(255, 0, 0, 0.2)'
    cans.textAlign = 'left'
    cans.textBaseline = 'middle'
    cans.fillText(str, can.width / 20, can.height)
  }

  const div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '3px'
  div.style.left = '0px'
  div.style.position = 'fixed'
  div.style.zIndex = '9999'
  div.style.width = document.documentElement.clientWidth + 'px'
  div.style.height = document.documentElement.clientHeight + 'px'
  div.style.background =
    'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}

// 该方法只允许调用一次
watermark.set = (str: any) => {
  const id = setWatermark(str)
  window.onresize = () => {
    setWatermark(str)
  }
}

export default watermark
